import Container from "react-bootstrap/Container"
import Nav from "react-bootstrap/Nav"
import Navbar from "react-bootstrap/Navbar"
import NavDropdown from "react-bootstrap/NavDropdown"

const MyNavbar = () => {
  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/">Matts Code Camp</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <NavDropdown title="Steps" id="basic-nav-dropdown">
              <NavDropdown.Item href="/Setup">Setup</NavDropdown.Item>
              <NavDropdown.Item href="/Config">Config</NavDropdown.Item>
              <NavDropdown.Item href="/Sprites">Sprites</NavDropdown.Item>
              <NavDropdown.Item href="/Animation">Animation</NavDropdown.Item>
              <NavDropdown.Item href="/PlayerInput">
                PlayerInput
              </NavDropdown.Item>
              <NavDropdown.Item href="/PlayerProjectiles">
                Player Projectiles
              </NavDropdown.Item>
              <NavDropdown.Item href="/Enemies">Enemies</NavDropdown.Item>
              <NavDropdown.Item href="/CollisionDetection">
                CollisionDetection
              </NavDropdown.Item>
              <NavDropdown.Item href="/KeepingScore">
                Keeping Score
              </NavDropdown.Item>
              <NavDropdown.Item href="/Sound">Sound</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="/Checkpoint">Checkpoint</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default MyNavbar
